import React from 'react';
import PropTypes from 'prop-types';
import { withCookies } from 'react-cookie';
import { withStyles } from '@material-ui/core/styles';
import dayjs from 'dayjs';
import { Paper, TableContainer, TableHead, TableRow, TableCell, Table, TableBody, Button} from '@material-ui/core';
import axios from 'axios';
import Common from '../Common';

const headCells = [
    { id: 'categoryId', numeric: false, disablePadding: false, label: 'ID', width: 'auto', textAlign: 'left' },
    { id: 'categoryName', numeric: false, disablePadding: false, label: '名前', width: 'auto', textAlign: 'left' },
    { id: 'createTime', numeric: false, disablePadding: false, label: '作成日時', width: 'auto', textAlign: 'left' },
    { id: 'note', numeric: false, disablePadding: false, label: '', width: 'auto', textAlign: 'left' },
    { id: 'status', numeric: true, disablePadding: false, label: '状態', width: 'auto', textAlign: 'center' },
];

const styles = () => ({
    root: {
        width: '100%',
    },
    paper: {
        maxWidth: 800,
        minWidth: 50,
        width: '95%',
        marginTop: '10px',
        marginLeft: '50px',
    },
    tableHeadColor: {
        backgroundColor: '#edeff0',
        borderColor: '#dee2e6',
        color: '#495057',
    },
    table: {
        maxWidth: 800,
        minWidth: 50,
    },
    cell: {
        display: 'block'
    },
});

function CategoryTableHead (props) {
    const { classes, order, orderBy } = props;

    return (
        <React.Fragment>
        <TableHead className={classes.tableHeadColor}>
            <TableRow>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.numeric ? 'center' : 'left'}
                        padding={headCell.disablePadding ? 'none' : 'default'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        {headCell.label}
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
        </React.Fragment>
    );
}

const CategoryTable = withCookies((props) => {
    const { classes, categoryList, switchStatus, cookies, nameObj } = props;
    const [order, setOrder] = React.useState('desc');
    const [orderBy, setOrderBy] = React.useState('createTime');
    const [update, setUpdata]= React.useState(false);
    headCells[3].label = nameObj.BIKO_NAME;
    const handleRequestSort = (_event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };


    const handleChangeStatus = (categoryData, status) => {
        const token = cookies.get('token');
        const jichitaiToken = cookies.get('x-jichitai-token');
        const jichitaiId = cookies.get('x-jichitai-jichitaiid');
        const kubunId = categoryData.counselingKubunId;
        let changeStatus = '有効';
        if(status === '1') changeStatus = '無効';
        const res = window.confirm(`「${categoryData.counselingKubunName}」を${changeStatus}にしますか？`);
        if(res){
            axios.post(
                `${Common.apiServerUrl()}/api/counseling/status`,
                {
                    kubunId,
                    status
                },
                {
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        'x-suppportcenter-token': token,
                        'x-jichitai-jichitaiid': jichitaiId,
                        'x-jichitai-token': jichitaiToken,
                    },
                }
            )
            .then(Common.handleErrors)
            .then((response) => {
                if (response.success) {
                    window.alert(`${changeStatus}にしました。`);
                    setUpdata(update ? false : true);
                    window.location.href = '/category';
                    return;
                } else {
                    window.alert(`code : [${response.type}]\nmessage : ${response.message}`);
                }
            })
            .catch((err) => {
                console.error('CategoryTable.js handleChangeStatus:put err:' + err);
            });
        }
    };

    return (
        <React.Fragment>
            <Paper className={classes.paper}>
                <TableContainer>
                    <Table className={classes.table} aria-labelledby="tableTitle" aria-label="draft table">
                        <CategoryTableHead
                            classes={classes}
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={handleRequestSort}
                            rowCount={categoryList.length}
                        />

                        <TableBody>
                            {categoryList.map((data, index) => {
                                const labelId = `deliveryError-data-table-checkbox-${index}`;
                                return (
                                    <TableRow
                                        hover
                                        tabIndex={-1}
                                        // key={data.recordId}
                                        key={data.recordId}
                                    >
                                        <TableCell
                                            component="th"
                                            id={labelId}
                                            // scope='row'
                                            padding={headCells[0].disablePadding ? 'none' : 'default'}
                                            align={'center'}
                                            style={{minWidth: '120px', textAlign: headCells[0].textAlign}}
                                        >
                                            <div className={classes.cell}>
                                                <p>{data.counselingKubunId}</p>
                                            </div>
                                        </TableCell>
                                        <TableCell
                                            component="th"
                                            id={labelId}
                                            // scope='row'
                                            padding={headCells[1].disablePadding ? 'none' : 'default'}
                                            align={'center'}
                                            style={{minWidth: '120px', textAlign: headCells[1].textAlign}}
                                        >
                                            <div className={classes.cell}>
                                                <p>{data.counselingKubunName}</p>
                                            </div>
                                        </TableCell>
                                        <TableCell
                                            component="th"
                                            id={labelId}
                                            // scope='row'
                                            padding={headCells[2].disablePadding ? 'none' : 'default'}
                                            align={'center'}
                                            style={{minWidth: '120px', textAlign: headCells[2].textAlign}}
                                        >
                                            <div className={classes.cell}>
                                                <p>{dayjs(data.createTime).format('YYYY-MM-DD HH:mm')}</p>
                                            </div>
                                        </TableCell>
                                        <TableCell
                                            component="th"
                                            id={labelId}
                                            // scope='row'
                                            padding={headCells[3].disablePadding ? 'none' : 'default'}
                                            align={'center'}
                                            style={{minWidth: '120px', textAlign: headCells[3].textAlign}}
                                        >
                                            <div className={classes.cell}>
                                                {data.note.split('\n').map((i) => {
                                                    return <p>{i}</p>
                                                })}
                                            </div>
                                        </TableCell>
                                        <TableCell
                                            component="th"
                                            id={labelId}
                                            // scope='row'
                                            padding={headCells[4].disablePadding ? 'none' : 'default'}
                                            align={'center'}
                                            style={{minWidth: '120px', textAlign: headCells[4].textAlign}}
                                        >
                                            { data.status === '0' && (switchStatus === 'BOTH' || switchStatus === 'INVALID')  && (
                                                <Button variant='contained' onClick={() => handleChangeStatus(data, '1')}>
                                                    <p>{'有効'}</p>
                                                </Button>
                                            )}
                                            { data.status === '0' && (switchStatus !== 'BOTH' && switchStatus !== 'INVALID') && (
                                                <div className={classes.cell}>
                                                    <p>{'有効'}</p>
                                                </div>
                                            )}
                                            { data.status === '1' && switchStatus === 'BOTH' && (
                                                <Button variant='contained' onClick={() => handleChangeStatus(data, '0')}>
                                                    <p>{'無効'}</p>
                                                </Button>
                                            )}
                                            { data.status === '1' && switchStatus !== 'BOTH'  && (
                                                <div className={classes.cell}>
                                                    <p>{'無効'}</p>
                                                </div>
                                            )}
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        </React.Fragment>
    );
});

CategoryTable.propTypes = {
    classes: PropTypes.object.isRequired,
    categoryList: PropTypes.array.isRequired,
    switchStatus: PropTypes.string.isRequired,
    cookies: PropTypes.object.isRequired,
};

CategoryTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired
};

export default withStyles(styles)(CategoryTable);